import { render, staticRenderFns } from "./AIDecision.vue?vue&type=template&id=60bb36d0"
import script from "./AIDecision.vue?vue&type=script&lang=js"
export * from "./AIDecision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports